import { action } from 'easy-peasy';
import { IAdminCommunitiesActions, IAdminCommunitiesState } from 'types/store/admin/communities';
import { IPendingCommunitiesResponseBody } from 'types/api/admin/communities';
import { ICommunityDetailsResponseBody } from 'types/api/community';

export const actions: IAdminCommunitiesActions = {
  setPendingCommunities: action<IAdminCommunitiesState, IPendingCommunitiesResponseBody>((state, payload) => {
    state.pendingCommunities = payload;
  }),
  startPendingCommunitiesLoading: action<IAdminCommunitiesState>((state) => {
    state.isPendingCommunitiesLoading = true;
  }),
  stopPendingCommunitiesLoading: action<IAdminCommunitiesState>((state) => {
    state.isPendingCommunitiesLoading = false;
  }),
  setCommunity: action<IAdminCommunitiesState, ICommunityDetailsResponseBody | null>((state, payload) => {
    state.community = payload;
  }),
};
